export default "__VITE_ASSET__a0efbd99__"